import styled from 'styled-components';

export const Label = styled.label`
  position: relative;
  display: inline-block;
  width: 55px;
  height: 30px;
  overflow: hidden;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
`;

export const Input = styled.input`
  display: none;
  appearance: none;

  &:checked + span:before {
    transform: translateX(24px);
  }
  &:checked + span {
    background-color: #37b635;
  }
`;

export const SwitchBox = styled.span`
  position: absolute;
  cursor: pointer;
  background-color: #7f899e;
  box-sizing: border-box;
  border-radius: 100px;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transition: background-color 0.2s ease;

  &:before {
    position: absolute;
    content: '';
    top: 5px;
    left: 5px;
    width: 20px;
    height: 20px;
    background-color: ${(props) => props.theme.colors.white};
    border-radius: 50%;
    transition: transform 0.3s ease;
    box-sizing: border-box;
  }
`;
